import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import CheckMark from '../CheckMark';
import Dropdown from '../Dropdown';
import styles from './AdditionalFeatures.module.scss';

const AdditionalFeatures = ({ infos }) => {
	const { t } = useTranslation('contractGenerator');

	return Array.isArray(infos) && infos.length > 0 ? (
		<>
			<Spacer height='m' />
			<Dropdown label={t('layouts.additionalFeatures.label')}>
				<FlexBox flexWrap='wrap'>
					{infos.map(infoSet => (
						<div key={infoSet[0]} className={styles.checkmarkWrap}>
							{infoSet.map(info => (
								<CheckMark key={info} text={info} />
							))}
						</div>
					))}
				</FlexBox>
			</Dropdown>
		</>
	) : (
		<></>
	);
};

AdditionalFeatures.propTypes = {
	infos: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired
};

export default AdditionalFeatures;
